import type { ReactNode } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Heading, Text } from "@/src/components/ui/Typography";

interface HeroProps {
  /** Rendered beside the heading on md+, below it on mobile. */
  search?: ReactNode;
}

export function Hero({ search }: HeroProps) {
  return (
    <Section className="bg-white">
      <Container>
        <div className="flex flex-col gap-10 md:flex-row md:justify-between items-center">
          <div>
            <Heading
              as="h1"
              size="displayXL"
              className="mt-4 max-w-200 text-center md:text-left"
            >
              Think It. Build It. Write It.
            </Heading>

            <Text
              size="bodyLG"
              className="mt-5 max-w-155 text-center text-neutral-700 md:text-left"
            >
              A space for builders, thinkers, and tech storytellers.
            </Text>
          </div>

          {search && <div className="w-full md:max-w-sm md:shrink-0">{search}</div>}
        </div>
      </Container>
    </Section>
  );
}
